export class NavigationView
{
	private readonly _nextMonthBtn: HTMLElement;
	private readonly _prevMonthBtn: HTMLElement;

	constructor(element: HTMLElement)
	{
		this._prevMonthBtn = document.getElementById("prevMonthBtn");
		this._nextMonthBtn = document.getElementById("nextMonthBtn");
	}

	public initNavNext(cb: () => void): void
	{
		this._nextMonthBtn.addEventListener("click", cb);
	}

	public initNavPrev(cb: () => void): void
	{
		this._prevMonthBtn.addEventListener("click", cb);
	}

	public reset(isPrevNavEnabled: boolean): void
	{
		this._prevMonthBtn.style.display = isPrevNavEnabled ? "block" : "none";
	}
}
